const ITEMS_LIST = {
    'kLLqDd4iTT0v7vBJNZCtB': {
        ID: 'kLLqDd4iTT0v7vBJNZCtB',
        itemImageURL: 'https://static.nirapara.com/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/i/d/idly.jpg',
        itemName: "Idly - 2pcs",
        itemPrice: '50',
        veg: true,
    },
    'wr4EYzzktmuVaS9zHGgSV': {
        ID: 'wr4EYzzktmuVaS9zHGgSV',
        itemImageURL: 'https://vaya.in/recipes/wp-content/uploads/2018/02/dreamstime_xs_44383666.jpg',
        itemName: "Vada - 1pc",
        itemPrice: '25',
        veg: true,
    },
    'xgos9RlLogi9CGYswmGw9': {
        ID: 'xgos9RlLogi9CGYswmGw9',
        itemImageURL: 'https://food.fnr.sndimg.com/content/dam/images/food/fullset/2019/10/9/DV3016_masala-dosa_s4x3.jpg.rend.hgtvcom.826.620.suffix/1570635680579.jpeg',
        itemName: "Dosa- 1pc",
        itemPrice: '60',
        veg: true,
    },
    'zmb8WlZS79bSsLlXJ2TKM': {
        ID: 'zmb8WlZS79bSsLlXJ2TKM',
        itemImageURL: 'https://cookwithrenu.com/wp-content/uploads/2019/03/Methi-Poori-_-3.jpg',
        itemName: "Meethi Puri - 2pcs",
        itemPrice: '120',
        veg: false,
    },
    'C3WqkQpLiIzUWBfdave04': {
        ID: 'C3WqkQpLiIzUWBfdave04',
        itemImageURL: 'https://i2.wp.com/pipingpotcurry.com/wp-content/uploads/2019/01/Roti-Chapati-Whole-Wheat-Indian-Flatbread-4.jpg',
        itemName: "Chapathi - 2pcs",
        itemPrice: '55',
        veg: true,
    },
    'JsrpLEYMNYy2qkHJHD5gG': {
        ID: 'JsrpLEYMNYy2qkHJHD5gG',
        itemImageURL: 'https://www.indianhealthyrecipes.com/wp-content/uploads/2016/06/masala-dosa-1.jpg',
        itemName: "Masala Dosa - 1pc",
        itemPrice: '70',
        veg: true,
    },
    'KHRqHQMqpqMaG4qfuHjuj': {
        ID: 'KHRqHQMqpqMaG4qfuHjuj',
        itemImageURL: 'https://i2.wp.com/www.vegrecipesofindia.com/wp-content/uploads/2016/01/tomato-upma-recipe-2.jpg',
        itemName: "Upma",
        itemPrice: '80',
        veg: true,
    },
    'pdT6iJ4qfvOg2JXuwAifI': {
        ID: 'pdT6iJ4qfvOg2JXuwAifI',
        itemImageURL: 'https://content.jdmagicbox.com/comp/unnao/h8/9999p5152.5152.190712214802.f8h8/catalogue/shree-radhe-momose-king-magii-point-unnao-pv7rozkngc.jpg',
        itemName: "Magii",
        itemPrice: '50',
        veg: true,
    },
    'aiMAhrzQ7nRnnenz17pzV': {
        ID: 'aiMAhrzQ7nRnnenz17pzV',
        itemImageURL: 'https://i0.wp.com/theindianclaypot.com/wp-content/uploads/2018/09/SCHEZWAN-CHICKEN-NOODLES.jpg?fit=1620%2C1080',
        itemName: "Chicken Noodles",
        itemPrice: '150',
        veg: false,
    },
    'PwyeoOfGzjiwSknMBOXcr': {
        ID: 'PwyeoOfGzjiwSknMBOXcr',
        itemImageURL: 'https://i2.wp.com/www.vegrecipesofindia.com/wp-content/uploads/2015/07/coriander-rice-recipe-1a-500x500.jpg',
        itemName: "coriander rice",
        itemPrice: '80',
        veg: true,
    },
    '1eLSLwXLebjDyCyTHebsv': {
        ID: '1eLSLwXLebjDyCyTHebsv',
        itemImageURL: 'https://www.bhimavaram.online/image/cache/food/fried%20rice/FR003-800x800.jpg',
        itemName: "Chicken Fried Rice",
        itemPrice: '180',
        veg: false,
    },
    'jc3FLbwIQOK6hVANDpPdJ': {
        ID: 'jc3FLbwIQOK6hVANDpPdJ',
        itemImageURL: 'https://www.southernplate.com/wp-content/uploads/2016/09/final-rice-beauty-foodsaver-scaled.jpg',
        itemName: "Veg Fried Rice",
        itemPrice: '160',
        veg: true,
    },
    'zMaHENkTZSwwyK7Cixjmn': {
        ID: 'zMaHENkTZSwwyK7Cixjmn',
        itemImageURL: 'https://upload.wikimedia.org/wikipedia/commons/e/e6/Malabar_Parota_and_egg_curry.JPG',
        itemName: "Egg Parota - 2,2Pcs",
        itemPrice: '140',
        veg: true,
    },
    'CM3p4uFSmp2aYKON6pTey': {
        ID: 'pdT6iJ4qfvOg2JXuwAifI',
        itemImageURL: 'https://media-cdn.tripadvisor.com/media/photo-s/0e/1c/29/2e/south-indian-meals.jpg',
        itemName: "South Indian Meals",
        itemPrice: '190',
        veg: true,
    },
    'PZxc163hp0c6gJMqum86Q': {
        ID: 'PZxc163hp0c6gJMqum86Q',
        itemImageURL: 'https://media-cdn.tripadvisor.com/media/photo-s/07/d3/75/ed/rassam.jpg',
        itemName: "North Indian Meals",
        itemPrice: '190',
        veg: true,
    },
    'bST4VfZjhvrR939GIzRIW': {
        ID: 'bST4VfZjhvrR939GIzRIW',
        itemImageURL: 'https://themom100.com/wp-content/uploads/2015/08/rice-in-bowl-horiz-with-spoon-copy.jpg',
        itemName: "Plain Rice",
        itemPrice: '40',
        veg: true,
    },
    'ztBFQU1tcJHleO4G0eo9B': {
        ID: 'ztBFQU1tcJHleO4G0eo9B',
        itemImageURL: 'https://www.cookwithmanali.com/wp-content/uploads/2019/07/Dal-Fry-Recipe-500x375.jpg',
        itemName: "Dal Fry",
        itemPrice: '140',
        veg: true,
    },
    'GALhR406gLVXo4gqdJjV2': {
        ID: 'GALhR406gLVXo4gqdJjV2',
        itemImageURL: 'https://www.indianhealthyrecipes.com/wp-content/uploads/2018/07/chicken-fry.jpg',
        itemName: "Chicken Fry",
        itemPrice: '160',
        veg: false,
    },
    '6fP6hFJzeDXZXwALPxk0L': {
        ID: '6fP6hFJzeDXZXwALPxk0L',
        itemImageURL: 'https://i1.wp.com/www.funloveandcooking.com/wp-content/uploads/2015/02/Panner-Fry-feature.jpg?fit=681%2C450',
        itemName: "Paneer Fry",
        itemPrice: '180',
        veg: true,
    },
    '6Jx7hAfWUumsdyOjcvw68': {
        ID: '6Jx7hAfWUumsdyOjcvw68',
        itemImageURL: 'https://www.archanaskitchen.com/images/archanaskitchen/0-Archanas-Kitchen-Recipes/Kesar_Pista_Lassi_Recipe-3.jpg',
        itemName: "Lassi",
        itemPrice: '50',
        veg: true,
    },
};
const CART_ITEMS_LIST = {};

export {ITEMS_LIST, CART_ITEMS_LIST};
